import React from 'react';
import { AuthButtonProps } from '../types';
import '../styles/modal.css';

export const AuthButton: React.FC<AuthButtonProps> = ({
  onClick,
  label = 'Sign In',
  primaryColor = '#6366f1',
  textColor = '#ffffff',
  className = '',
}) => {
  return (
    <button
      className={`gamepass-auth-button ${className}`}
      onClick={onClick}
      style={{
        backgroundColor: primaryColor,
        color: textColor,
      }}
    >
      {label}
    </button>
  );
};